import React from "react";
import ReactFileReader from "react-file-reader";
import PostFilesAxios from "../axiosComponent/postFilesAxios";
import cogoToast from "cogo-toast";

const UploadPODFile = ({ field: { name }, form: { setFieldValue }, ...props }) => {

  const handleFiles = (files) => {
    let data = {
        documentContent: files.fileList[0],
        documentName: name,
        orderNo: props.values.orderNo ? props.values.orderNo : "",
        deliveryNo: props.values.deliveryNo ? props.values.deliveryNo : "",
      };
      PostFilesAxios({
        //url: `pod/podDetails/delivery_primary`,
        url: `pod/document`,
        createItems: data,
        
      })
      .then((res)=>{setFieldValue(name, files);cogoToast.success('Uploaded Success');})
      .catch((err)=>{console.log(err);cogoToast.error(err);})
  

  };

  return (
    <>
      <ReactFileReader
        base64={true}
        fileTypes={props.typer}
        handleFiles={handleFiles}
        {...props}
      >
        <button type="button" className={props.className}>
          <i className="fas fa-upload"></i> {props.buttonName}
        </button>
      </ReactFileReader>
    </>
  );
};

export default UploadPODFile;
